module.exports = __webpack_public_path__ + "img/SharpnessEnhancement05.88270074.png";